import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  components,
  directives,
  defaults: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VCard: {
      elevation: 2,
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VTextField: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VSelect: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VAutocomplete: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VCombobox: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VTextarea: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VCheckbox: {
      density: 'compact',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    VSwitch: {
      density: 'compact',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#000f09',
          secondary: '#e0efff',
          accent: '#f5e081',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          background: '#F4F5F7',
        },
      },
      dark: {
        colors: {},
      },
    },
  },
});
